import { RefObject, useEffect, useRef, useState } from 'react';

type UseSectionOpenStateOptions = {
  defaultOpen?: boolean;
  submitCount?: number;
  hasError?: boolean;
  errorAnchorRef?: RefObject<HTMLElement | null>;
};

export const useSectionOpenState = ({
  defaultOpen = true,
  submitCount,
  hasError = false,
  errorAnchorRef,
}: UseSectionOpenStateOptions = {}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const lastSubmitCount = useRef(submitCount);
  const [pendingScroll, setPendingScroll] = useState(false);

  useEffect(() => {
    if (submitCount === undefined) return;
    if (submitCount === lastSubmitCount.current) return;
    lastSubmitCount.current = submitCount;
    if (!hasError) return;
    setIsOpen(true);
    if (errorAnchorRef) setPendingScroll(true);
  }, [submitCount, hasError, errorAnchorRef]);

  useEffect(() => {
    if (!pendingScroll || !isOpen) return;
    errorAnchorRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    setPendingScroll(false);
  }, [pendingScroll, isOpen, errorAnchorRef]);

  return { isOpen, setIsOpen };
};
